import React from "react";
import Section1 from "../components/Technology/Section1";
import Section2 from "../components/Technology/Section2";
import SEO from "../components/SEO";

const technologySchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Publishing Technology Stack Solutions",
  "provider": {
    "@type": "Organization",
    "name": "Transforma Pvt Ltd",
    "url": "https://www.transforma.in/technology"
  },
  "description": "Transforma leverages a cutting-edge technology stack including Artificial Intelligence (AI), Machine Learning (ML), Natural Language Processing (NLP), and workflow automation to power publishing excellence and deliver high-quality content solutions.",
  "keywords": "publishing technology stack, artificial intelligence in publishing, machine learning content analysis, natural language processing tools, workflow automation solutions, intelligent content management, automated text analysis, scalable publishing solutions"
};

const Technology = () => {
  return (
    <>
    <SEO
        title="Advanced Publishing Technology Stack | AI, ML & Automation | Transforma"
        description="Powering publishing excellence through advanced technology. Explore how Transforma integrates AI, Machine Learning, NLP, and intelligent workflow automation to streamline content conversion and management."
        keywords="publishing technology stack, AI publishing solutions, machine learning content analysis, natural language processing tools, workflow automation systems, text categorization, sentiment analysis, intelligent content management, scalable publishing tech"
        canonical="https://www.transforma.in/technology"
        schema={technologySchema}
      />
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px]  ruler">
      <Section1 />
      <Section2 />
    </div>
    </>
  );
};

export default Technology;
